/**
 * WordPress dependencies
 */
import { comment as icon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  __experimental: "fse",
  name: "core/post-comment",
  title: "Post Comment (deprecated)",
  category: "theme",
  description: "This block is deprecated. Please use the Comments block instead.",
  textdomain: "default",
  attributes: {
    commentId: {
      type: "number"
    }
  },
  providesContext: {
    commentId: "commentId"
  },
  supports: {
    html: false,
    inserter: false
  }
};
import edit from './edit';
import save from './save';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon,
  edit,
  save
};
//# sourceMappingURL=index.js.map